import React from "react";
import { useLocation } from "react-router-dom";
import CustomNavLink from "./CustomNavLink";
import "./CustomNavDropdown.scss";

function CustomNavDropdown({ label, items }) {
    const location = useLocation();

    // Check if any item matches the current path
    const isActive = items.some(item => location.pathname === item.to);

    return (
        <div className="custom-nav-dropdown">
            <div className={`nav-link custom-dropdown-label ${isActive ? 'active' : ''}`}>
                {label}
            </div>
            <div className="custom-dropdown-content">
                {items.map((item) => (
                    <CustomNavLink
                        key={item.to}
                        to={item.to}
                        text={item.text}
                        className="custom-dropdown-item"
                    />
                ))}
            </div>
        </div>
    );
}

export default CustomNavDropdown;
